import common from "@page/common/js/common";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  preLoad: 0.8,
  error: "",
  loading: "https://static.tpx.tw/sff/yuyu/static/img/loading-bar.gif",
  attempt: 1,
  listenEvents: ["scroll", "wheel", "mousewheel"],
});

new Vue({
  el: "#member-member-discount",
  data: {
    articleCategories: [],
    gymData: [
      {
        City: "新北市",
        Code: "New Taipei City",
        Gym: [
          {
            Name: "TRUE YOGA FITNESS",
            Area: "中和館",
            Program: "14天免費3堂課體驗",
            Address: "新北市中和區中山路二段291號8-9樓",
            Id: "01",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/391d82f0-25ac-483d-9c45-44337b175f41.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "汐止館",
            Program: "14天免費3堂課體驗",
            Address: "新北市汐止區新台五路一段93號4樓",
            Id: "02",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/388c0650-5c73-43d7-9bd0-7d0ad46f7a72.jpg",
          },
          {
            Name: "Hypercore Fitness 超核心健身中心",
            Area: "中和中山館",
            Program: "免費體驗14天 + inbody測量解說一次",
            Address: "新北市中和區中山路二段122號B1",
            Id: "03",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/ae8b14ff-5113-406e-ada3-bec77a3569ed.jpg",
          },
          {
            Name: "TYR GYM",
            Area: "三重旗艦館",
            Program: "免費體驗一次(團體課程、器材限擇一)",
            Address: "新北市三重區正義南路123號B1",
            Id: "04",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/98dbb135-544c-4aff-b1f2-fe406166023a.jpg",
          },
        ],
      },
      {
        City: "台北市",
        Code: "Taipei City",
        Gym: [
          {
            Name: "nisorofit",
            Area: "南京旗艦館",
            Program: "七日健身房會籍 + 教練體驗課一堂 + inbody測量一次",
            Address: "台北市松山區南京東路五段176號",
            Id: "05",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/67a8be77-a15f-4366-beb0-e61554712341.jpg",
          },
          {
            Name: "Hypercore Fitness 超核心健身中心",
            Area: "信義松仁館",
            Program: "免費體驗14天 + inbody測量解說一次",
            Address: "台北市信義區松仁路89號B1",
            Id: "06",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/856c4e1f-d3c3-44a8-8215-777d4ff0cf0d.jpg",
          },
          {
            Name: "Hypercore Fitness 超核心健身中心",
            Area: "忠孝市府館",
            Program: "免費體驗14天 + inbody測量解說一次",
            Address: "台北市信義區基隆一段200號B2",
            Id: "07",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/7df2a882-37cd-480a-93e1-53935af2cefd.jpg",
          },
          {
            Name: "Hypercore Fitness 超核心健身中心",
            Area: "內湖成功館",
            Program: "免費體驗14天 + inbody測量解說一次",
            Address: "台北市內湖區成功路四段168號B2",
            Id: "08",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/7aa38ee1-ddfd-4e84-b2b6-ae8bbb5bb930.jpg",
          },
          {
            Name: "XOJON lifestyle",
            Area: "台北大直館",
            Program: "免費體驗課程一次",
            Address: "台北市中山區樂群三路289號",
            Id: "09",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/5aa5ec2f-6e71-4bcd-8f14-08165a1b072b.jpg",
          },
          {
            Name: "YOGA EDITION",
            Area: "敦南會館",
            Program: "免費瑜珈專場體驗課程(實際課堂日期、時段後續公布，詳YUYU官方訊息)",
            Address: "台北市大安區忠孝東路四段151號",
            Id: "10",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/68ee9b6a-210d-419f-b767-890b1b6878d3.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "微風南京館",
            Program: "14天免費3堂課體驗",
            Address: "台北市松山區南京東路四段2號(小巨蛋內)",
            Id: "11",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/fbdf1566-f037-4180-ac82-b048dee0fd93.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "忠孝旗艦館",
            Program: "14天免費3堂課體驗",
            Address: "台北市信義區忠孝東路四段563號B1-1樓",
            Id: "12",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/d7282c52-ea98-446d-a0ed-d72037758a4c.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "內湖館",
            Program: "14天免費3堂課體驗",
            Address: "台北市內湖區內湖路一段659號B1",
            Id: "13",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/00018067-5303-4c2a-84f1-0805226a3235.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "古亭館",
            Program: "14天免費3堂課體驗",
            Address: "台北市中正區和平西路一段2號B1-3樓",
            Id: "14",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/3ab707d2-3d8a-47b8-9998-ca7c402a4579.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "南港館",
            Program: "14天免費3堂課體驗",
            Address: "台北市南港區經貿二路188號4樓",
            Id: "15",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/200138ba-04f6-446a-8faa-c605de3c5e5b.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "天母館",
            Program: "14天免費3堂課體驗",
            Address: "台北市士林區忠誠路二段188號B1樓,2樓)",
            Id: "16",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/d35aba8d-9439-44c5-be6e-4a8b1e5c3105.jpg",
          },
        ],
      },
      {
        City: "桃園市",
        Code: "Taoyuan City",
        Gym: [
          {
            Name: "TRUE YOGA FITNESS",
            Area: "桃園館",
            Program: "14天免費3堂課體驗",
            Address: "桃園市桃園區同德五街77號5-6樓(中茂新天地)",
            Id: "17",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/1644a932-2ab9-43a3-9f92-177dd84ca4c3.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "中壢館",
            Program: "14天免費3堂課體驗",
            Address: "桃園市中壢區中美路一段12號7-9樓(近中壢SOGO商圈)",
            Id: "18",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/ca0f0f00-58fb-4f03-affd-ad2f53185c45.jpg",
          },
        ],
      },
      {
        City: "台中市",
        Code: "Taichung City",
        Gym: [
          {
            Name: "ACTION FITNESS 啟動健身中心",
            Area: "五權館",
            Program: "免費體驗7天 + 體驗團體課程1次 + 在體驗完加入送Inbody測量一次、教練課一堂、入會禮",
            Address: "台中市北區五權路375號11/12F",
            Id: "19",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/dfefefcf-b839-431b-9371-f3822b8fd003.jpg",
          },
          {
            Name: "ACTION FITNESS 啟動健身中心",
            Area: "中科館",
            Program: "免費體驗7天 + 體驗團體課程1次 + 在體驗完加入送Inbody測量一次、教練課一堂、入會禮",
            Address: "台中市西屯區國安一路168號5F",
            Id: "20",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/ca39c130-6949-4064-a551-4f49d1654cab.jpg",
          },
          {
            Name: "Harfez Fitness 力宴健身",
            Area: "西區",
            Program: "免費7天體驗+教練課程體驗一堂+InBody測量解說一次",
            Address: "台中市西區忠明路30號2樓",
            Id: "21",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/04ecf939-ddf6-4bc6-b8e8-812421562431.jpg",
          },
          {
            Name: "Hypercore Fitness 超核心健身中心",
            Area: "台灣大道館",
            Program: "免費體驗14天 + inbody測量解說一次",
            Address: "台中市西區台灣大道二段489號B1",
            Id: "22",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/e44286df-5a4b-41b2-abbe-87ce148fbbe0.jpg",
          },
          {
            Name: "TRUE YOGA FITNESS",
            Area: "台中館",
            Program: "14天免費3堂課體驗",
            Address: "台中市西區健行路1049號5樓(金典綠園道)",
            Id: "23",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/b5df0324-a3f8-4c37-8aee-e975f7e7aa8b.jpg",
          },
        ],
      },
      {
        City: "嘉義市",
        Code: "Chiayi City",
        Gym: [
          {
            Name: "TRUE YOGA FITNESS",
            Area: "嘉義館",
            Program: "14天免費3堂課體驗",
            Address: "嘉義市西區文化路299號6-7樓",
            Id: "24",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/d5180130-38e0-4633-bf16-91d3c7067b56.jpg",
          },
        ],
      },
      {
        City: "台南市",
        Code: "Tainan City",
        Gym: [
          {
            Name: "MoveWell",
            Area: "安平館",
            Program: "一對一健身教練課體驗一次 + 免費14天會籍",
            Address: "台南市安平區文平路1號",
            Id: "25",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/0eed8479-8ec1-41bb-b8d0-80271bf9b551.jpg",
          },
          {
            Name: "倍速運動健身房",
            Area: "北區旗艦館",
            Program: "會員體驗課程一堂(市價$800) + 體驗後若購買24堂送1堂專項課、購買36堂以上送2堂(市價$800/堂)",
            Address: "台南市北區大興街233巷56號",
            Id: "26",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/512b53e3-dc40-4a56-8fc3-0be56b7e2105.jpg",
          },
          {
            Name: "倍速運動健身房",
            Area: "東區帝心館",
            Program: "會員體驗課程一堂(市價$800) + 體驗後若購買24堂送1堂專項課、購買36堂以上送2堂(市價$800/堂)",
            Address: "台南市東區崇善路25巷120號",
            Id: "27",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/98acb7be-a482-43b2-8980-e0e83a321f40.jpg",
          },
          {
            Name: "倍速運動健身房",
            Area: "永康區東橋館",
            Program: "會員體驗課程一堂(市價$800) + 體驗後若購買24堂送1堂專項課、購買36堂以上送2堂(市價$800/堂)",
            Address: "台南市永康區東橋五路102號",
            Id: "28",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/6b7c06eb-01b7-4b2b-9548-e79692d0c92d.jpg",
          },
          {
            Name: "倍速運動健身房",
            Area: "台南東橋二館",
            Program: "會員體驗課程一堂(市價$800) + 體驗後若購買24堂送1堂專項課、購買36堂以上送2堂(市價$800/堂)",
            Address: "台南市永康區東橋七路155號",
            Id: "29",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/ddcd4241-cf68-4b99-a358-a913060f0e12.jpg",
          },
          {
            Name: "倍速運動健身房",
            Area: "仁德上東城館",
            Program: "會員體驗課程一堂(市價$800) + 體驗後若購買24堂送1堂專項課、購買36堂以上送2堂(市價$800/堂)",
            Address: "台南市仁德區文心路68號",
            Id: "30",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/23e5f908-f849-4199-8b1c-8702dda08c09.jpg",
          },
        ],
      },
      {
        City: "高雄市",
        Code: "Kaohsiung City",
        Gym: [
          {
            Name: "FREELIFE STUDIO 自由生活運動工作室",
            Area: "左營自由館",
            Program: "免費體驗14天",
            Address: "高雄市左營區自由二路108號3樓",
            Id: "31",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/d052feb4-eae9-48d0-bd2f-4380e40e9fd2.jpg",
          },
          {
            Name: "FREELIFE STUDIO 自由生活運動工作室",
            Area: "新興站前館",
            Program: "免費體驗14天",
            Address: "高雄市新興區中山一路253-1號",
            Id: "32",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/04ea9366-c94b-4850-bd1e-e8b15570463a.jpg",
          },
          {
            Name: "倍速運動健身房",
            Area: "高雄左營館",
            Program: "會員體驗課程一堂(市價$800) + 體驗後若購買24堂送1堂專項課、購買36堂以上送2堂(市價$800/堂)",
            Address: "高雄市左營區自由二路116號",
            Id: "33",
            CoverImage: "https://pics.yuyu-active.com/yuyu-t/System/1e985e48-3239-4a89-8ab8-6a7976499ef7.jpg",
          },
        ],
      },
    ],
    lastArticleLink: "",
    nextArticleLink: "",
    categoryIsLoad: false,
  },
  computed: {
    dataIsLoad() {
      if (this.articleCategories.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    getArticleCategory() {
      if (this.articleCategories.length !== 0) {
        if (this.articleCategories.find((cate) => cate.Code === location.href.split("/brand/")[1])) {
          const findIndex = this.articleCategories.findIndex((cate) => cate.Code === location.href.split("/brand/")[1]);
          if (findIndex === 0) {
            this.lastArticleLink = "/brand/";
          } else {
            this.lastArticleLink = "/brand/" + this.articleCategories[findIndex - 1].Code;
          }
          if (this.articleCategories.length === 1 || findIndex === this.articleCategories.length - 1) {
            this.nextArticleLink = "/brand/";
          } else {
            this.nextArticleLink = "/brand/" + this.articleCategories[findIndex + 1].Code;
          }
          console.log("findIndex", findIndex, this.lastArticleLink, this.nextArticleLink);
          return this.articleCategories.find((cate) => cate.Code === location.href.split("/brand/")[1]).Name;
        } else {
          this.lastArticleLink = "/brand/" + this.articleCategories.at(-1).Code;
          this.nextArticleLink = "/brand/" + this.articleCategories[0].Code;
          console.log("lastArticleLink", this.lastArticleLink, "nextArticleLink", this.nextArticleLink);
          return "All Categories";
        }
      }
    },
  },
  created: function () {
    this.getCategory();
  },
  methods: {
    getCategory: function () {
      var self = this;
      self.categoryIsLoad = false;
      $.ajax({
        type: "GET",
        url: API_URL.ARTICLE_CATEGORY,
        data: {
          articleSource: "brand",
        },
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        error: function () {
          console.log("error");
        },
        success: function (res) {
          if (res.Code === 200) {
            self.articleCategories = res.Response.Categories;
            self.categoryIsLoad = true;
          } else {
            AlertDialog.alert("系統忙線中,請稍後再試", function () {
              window.location.href = "/";
            });
          }
        },
      });
    },
  },
});
